export default function AttachRecommendationFolderDirective() {
  return {
    template: require('./attach-recommendation-folder.html'),
    scope: {
      customerId: '=',
      recommendationId: '=',
      serviceId: '=',
      parentFolderId: '=',
      folderId: '=',
      folder: '=',
    },
    controller: 'AttachRecommendationFolderController',
    controllerAs: 'attachRecommendationFolderVM',
    bindToController: true,
    replace: true
  };
}
